import {
  AriaAttributes,
  AriaRole,
  CSSProperties,
  FocusEvent,
  KeyboardEvent,
  ReactNode,
  Ref,
} from 'react';

type DragAndDropVirtualItemProps = {
  /** Read by `DragAndDropSectionsProvider` to place drop indicators. */
  dragAndDropCardId: string;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  ref?: Ref<HTMLDivElement>;
  role?: AriaRole;
  tabIndex?: number;
  onKeyDown?: (event: KeyboardEvent<HTMLDivElement>) => void;
  onFocus?: (event: FocusEvent<HTMLDivElement>) => void;
  'data-index'?: number;
} & AriaAttributes;

/**
 * Wrapper for a single card of a windowed drag-and-drop list, giving the
 * virtualizer an element to measure without hiding the card id from the
 * surrounding `DragAndDropSectionsProvider`.
 */
export const DragAndDropVirtualItem = ({
  dragAndDropCardId: _dragAndDropCardId,
  children,
  ref,
  ...rest
}: DragAndDropVirtualItemProps) => (
  <div ref={ref} {...rest}>
    {children}
  </div>
);
